/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled, TextField } from "@mui/material";

export const StyledSearchBar = styled(TextField)({
  '&:hover': {
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #2b4fb9 !important',
    },
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderWidth: '1px',
    borderRadius: '25px',
  },
  '& .MuiInputBase-root': {
    borderRadius: '25px',
    height: '2.4rem',
    paddingTop: '3px',
    fontSize: '15px',
    width: '253px !important',
    backgroundColor: 'white',
  },
});
